import { render, staticRenderFns } from "./ordersListTable.vue?vue&type=template&id=0e2e6147&scoped=true"
import script from "./ordersListTable.vue?vue&type=script&lang=js"
export * from "./ordersListTable.vue?vue&type=script&lang=js"
import style0 from "./ordersListTable.vue?vue&type=style&index=0&id=0e2e6147&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e6147",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e2e6147')) {
      api.createRecord('0e2e6147', component.options)
    } else {
      api.reload('0e2e6147', component.options)
    }
    module.hot.accept("./ordersListTable.vue?vue&type=template&id=0e2e6147&scoped=true", function () {
      api.rerender('0e2e6147', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/components/ordersListTable.vue"
export default component.exports